import type { ReactNode } from 'react';

interface DocWarningProps {
  /** Collapsed-state teaser shown in the <summary>. */
  summary: string;
  /** Full warning body, revealed on expand. */
  children: ReactNode;
  /** Defaults to closed per Ellis 2026-05-31 (subtle, not a loud callout). */
  defaultOpen?: boolean;
}

/**
 * Subtle, collapsible version-status callout. Replaces the old loud yellow
 * `<div class="doc-warning">` box. Closed by default; styled subtle amber via
 * legal-document.css (.doc-warning).
 */
export function DocWarning({ summary, children, defaultOpen = false }: DocWarningProps) {
  return (
    <details className="doc-warning" open={defaultOpen}>
      <summary>{summary}</summary>
      <div className="doc-warning-body">{children}</div>
    </details>
  );
}
